import type { SegmentEvent } from '@segment/analytics-next';

import { TRACKING_PLAN_VERSION } from '../constants';
import type {
  TranscendBaseContext,
  TranscendIndividualContext,
  TranscendIndividualTraits,
} from '../types';

type WithTrackingPlanVersion<T> = T & {
  trackingPlanVersion: typeof TRACKING_PLAN_VERSION;
};

export function formatBaseContext(
  context: SegmentEvent['context'],
): WithTrackingPlanVersion<TranscendBaseContext> {
  return {
    trackingPlanVersion: TRACKING_PLAN_VERSION,
    ...context,
  };
}

/**
 * Used by .identify() and .track() calls to format the individual's `context` object
 * @see https://segment.com/docs/connections/spec/common/#context
 */
export function formatIndividualContext({
  context,
  formattedTraits,
}: {
  context: TranscendIndividualContext | undefined;
  /** The result of formatIdentify */
  formattedTraits: TranscendIndividualTraits | undefined;
}): WithTrackingPlanVersion<TranscendIndividualContext> {
  const baseContext = formatBaseContext(context);
  return {
    ...baseContext,
    traits: {
      ...baseContext?.traits,
      ...formattedTraits,
    },
  };
}
